// helper for international price format
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
var formatPrice = function(number, currency, locale, options) {
    if (Number.isNaN(number) || currency === "") {
        return undefined;
    }
    return new Intl.NumberFormat(locale, _object_spread({
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }, options)).format(number);
};
export { formatPrice };
